module.exports = __webpack_public_path__ + "static/bg_white-7f8ead4e41c5ecb0247eca959acd438d.mp4";